// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkflowNodeActionsTool__allowsSubmenu___aMBDh {
    overflow: visible;
}

.WorkflowNodeActionsTool__allowsSubmenu___aMBDh:has([data-floating-tool-open="true"]) {
    border-color: rgba(226, 181, 85, 0.78);
    background: rgba(19, 31, 34, 0.92);
    box-shadow:
        0 0 0 1px rgba(0, 0, 0, 0.18),
        0 0 10px rgba(210, 155, 40, 0.2);
    color: rgba(235, 211, 145, 1) !important;
    filter: brightness(1.18) saturate(1.08);
}

.WorkflowNodeActionsTool__allowsSubmenu___aMBDh:has([data-floating-tool-open="true"]) .glyphicon {
    color: rgba(235, 211, 145, 1) !important;
}

.WorkflowNodeActionsTool__tool___xRODv {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.WorkflowNodeActionsTool__submenu___y0eSz {
    position: absolute;
    top: 50%;
    right: 46px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    width: auto !important;
    height: auto !important;
    padding: 4px;
    border: 1px solid rgba(194, 151, 65, 0.28);
    border-radius: 18px;
    background: rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(5px);
    box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.06),
        0 6px 16px rgba(0, 0, 0, 0.24);
    transform: translateY(-50%);
}

.WorkflowNodeActionsTool__submenu___y0eSz::before {
    position: absolute;
    top: 19px;
    right: -6px;
    bottom: 19px;
    width: 1px;
    background: rgba(157, 166, 158, 0.18);
    content: "";
}

.WorkflowNodeActionsTool__submenu___y0eSz::after {
    position: absolute;
    top: 50%;
    left: 100%;
    width: 15px;
    height: 1px;
    background: rgba(157, 166, 158, 0.18);
    content: "";
}

.WorkflowNodeActionsTool__subAction___eHBqb {
    display: flex;
    width: 30px !important;
    height: 30px !important;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(194, 151, 65, 0.25);
    border-radius: 999px;
    background: rgba(4, 10, 13, 0.46);
    color: rgba(183, 202, 198, 0.78);
}

.WorkflowNodeActionsTool__subAction___eHBqb:not(:has(*)) {
    display: none;
}

.WorkflowNodeActionsTool__subAction___eHBqb:hover,
.WorkflowNodeActionsTool__subAction___eHBqb:focus-within {
    border-color: rgba(226, 181, 85, 0.68);
    color: rgba(221, 232, 228, 0.98);
}

.WorkflowNodeActionsTool__subAction___eHBqb:has([data-is-favorite="true"]) {
    border-color: hsl(94deg 72% 34%);
    background: hsl(94deg 72% 34%);
    color: hsl(220deg 18% 9%);
}

.WorkflowNodeActionsTool__subAction___eHBqb:has([data-is-selecting="true"]) {
    border-color: rgba(121, 217, 238, 0.72);
    color: #8fe8ff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allowsSubmenu": `WorkflowNodeActionsTool__allowsSubmenu___aMBDh`,
	"tool": `WorkflowNodeActionsTool__tool___xRODv`,
	"submenu": `WorkflowNodeActionsTool__submenu___y0eSz`,
	"subAction": `WorkflowNodeActionsTool__subAction___eHBqb`
};
module.exports = ___CSS_LOADER_EXPORT___;
